var _defs, _path, _polyline, _polyline2, _path2, _path3, _ellipse, _polyline3, _polyline4, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessionalLiability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 48,
    height: 48,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-linejoin:round;stroke-width:2px;}.cls-1{stroke:#fad238;}.cls-1,.cls-3{stroke-linecap:round;}.cls-2,.cls-3{stroke:#acb5bf;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "professional-liability") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,31.05A5.21,5.21,0,0,0,37.08,31,12.81,12.81,0,0,0,40,29a12.88,12.88,0,0,0,3,2,4.91,4.91,0,0,0,4,.05v5.36c0,4.86-2.7,8.32-7,10.59-4.3-2.27-7-5.73-7-10.59Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37 39 39 41 43 36"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "28.15 25.86 28.15 32.41 31 34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.93,26.31v6.1l-11.24,4a6.73,6.73,0,0,0-4.47,6.34v2A2.24,2.24,0,0,0,3.47,47H33.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.41,13.24c-.38,0-.67,0-1,.1-3.82.74-6.28-.65-8.38-4.33-1.26,2.42-5.21,4.33-8.45,4.33a9,9,0,0,1-4.34-1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 22.26,
    cy: 14.46,
    rx: 11.22,
    ry: 13.46
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17 33 23 38 28 33"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17 32 14 37 23 38 31 37"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23,
    y1: 38,
    x2: 23,
    y2: 46
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10,
    y1: 42,
    x2: 14,
    y2: 42
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalLiability);
export default __webpack_public_path__ + "static/media/professional-liability.3722014f81d59a02e90868647fd0f596.svg";
export { ForwardRef as ReactComponent };